var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "d-flex flex-column align-items-center"
    },
    [
      _c(
        "h2",
        {
          staticClass: "text-h4 text-center mb-4"
        },
        [_vm._v(_vm._s(_vm.title))]
      ),
      _c(
        "p",
        {
          staticClass: "text-subtitle-1 text-center mb-8"
        },
        [_vm._v(_vm._s(_vm.description))]
      ),
      _c(
        "gg-btn",
        {
          staticClass: "mb-2",
          on: {
            click: function click($event) {
              return _vm.$emit("start")
            }
          }
        },
        [_vm._v("Get Started")]
      ),
      _c(
        "gg-btn",
        {
          attrs: {
            text: ""
          },
          on: {
            click: function click($event) {
              return _vm.$emit("skip")
            }
          }
        },
        [_vm._v("Skip for now")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }